import { render, staticRenderFns } from "./comp6-2.vue?vue&type=template&id=45032dd2&scoped=true"
import script from "./comp6-2.vue?vue&type=script&lang=ts"
export * from "./comp6-2.vue?vue&type=script&lang=ts"
import style0 from "./comp6-2.vue?vue&type=style&index=0&id=45032dd2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45032dd2",
  null
  
)

export default component.exports